export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6250.79067956.jpg";